// SPDX-FileCopyrightText: 2024 John Livingston <https://www.john-livingston.fr/>
//
// SPDX-License-Identifier: AGPL-3.0-only

export const XMLNS_POLL = 'http://jabber.org/protocol/muc#x-poll'
export const XMLNS_POLL_MESSAGE = 'http://jabber.org/protocol/muc#x-poll-message'
export const POLL_MESSAGE_TAG = 'x-poll'
export const POLL_QUESTION_TAG = 'x-poll-question'
export const POLL_CHOICE_TAG = 'x-poll-choice'
